import { getItem, removeItem, setItem } from './storage';

const UserCheckKey = 'lqaAcademyUserList';

export const shouldShowLqaAcademyModal = () => {
  removeItem('lqaAcademyPopupDateStamp');
  return getItem(UserCheckKey) === null;
};

export const markLqaAcademyModalSeen = () => {
  setItem(UserCheckKey, JSON.stringify(true));
};
